import Box from "@/components/Box";

export default function Asterisk({ fontFamily, fontSize }) {
  return (
    <Box as="span" color="red" fontFamily={fontFamily} fontSize={fontSize}>
      *
    </Box>
  );
}
